import SwaggerClient from 'swagger-client';
import { COOKIES } from '../constants/cookies';
import { httpCodes, httpHeaders } from '../constants/httpMethods';
import { FEATURE_FLAG } from '../constants/endpoints';
import MixpanelConfig from '../constants/mixpanelConfig';
import ROUTES from '../../components/Routes/constants';
import MixpanelService from '../../services/MixpanelService';
import swaggerJSON from './swagger/swagger.json';
import { getCookie } from '../utils/cookies';
import AuthService from '../../services/AuthService';
import OktaAuthManagementService from '../../services/OktaAuthManagementService';
import isOmpPlatform from '../utils/isOmpPlatform';
import OKTA_CONFIG from '../constants/oktaConfig';
import renderLocale from '../helpers/renderLocale';

let apiClient;

const topLevelRequestInterceptor = req => {
  const oktaStorage = localStorage.getItem(OKTA_CONFIG.oktaTokenStorage);
  const url = new URL(req.url);

  if (
    (url.pathname === '/api/bid/place' ||
      url.pathname === '/api/bid/proxy-upcoming/place' ||
      url.pathname === '/api/shipping/estimate') &&
    oktaStorage
  ) {
    if (oktaStorage && JSON.parse(oktaStorage)?.accessToken?.accessToken) {
      req.headers.authorization = `Bearer ${
        JSON.parse(oktaStorage).accessToken.accessToken
      }`;
      req.headers.clientIdentifier = `${httpHeaders.clientIdentifierOmpWeb}`;
    }
  } else {
    req.headers.authenticationToken = getCookie(COOKIES.AUTH_TOKEN);
    req.headers.clientIdentifier = `${httpHeaders.clientIdentifier}`;
  }

  const betaOptedIn = getCookie(COOKIES.BETA_OPTED_IN);

  if (process.env.REACT_APP_GIT_TAG) {
    req.headers.clientIdentifier += `-${process.env.REACT_APP_GIT_TAG}`;
  }

  if (req.url.includes(FEATURE_FLAG.RETRIEVE_ALL) && betaOptedIn) {
    req.headers[COOKIES.BETA_OPTED_IN] = betaOptedIn;
  }

  req.headers['Accept-Language'] = renderLocale();

  return req;
};

const ApiService = async () => {
  if (apiClient) {
    return apiClient;
  }

  swaggerJSON.host = process.env.REACT_APP_API_HOST;
  swaggerJSON.schemes = [process.env.REACT_APP_API_SCHEMES];

  // eslint-disable-next-line require-atomic-updates
  apiClient = await new SwaggerClient({
    spec: swaggerJSON,
    requestInterceptor: topLevelRequestInterceptor,
    responseInterceptor(res) {
      if (res.status === httpCodes.UNAUTHORIZED && !isOmpPlatform()) {
        // If user doesn't have a valid session take the user back to TR4 and add a tracking event
        const request = this;
        const { pathname } = window.location;
        const mixpanel = MixpanelService.get();
        mixpanel.track(MixpanelConfig.names.sessionNotValid, {
          path: pathname,
          api: request.url
        });
        // Clear storage
        AuthService.clearStorage();
        OktaAuthManagementService.get().logoutOktaSession();
        window.location.replace(ROUTES.TR4_ENDPOINT);
      }
      if (res.status === httpCodes.UNAUTHORIZED && isOmpPlatform()) {
        // TODO discuss the effect of this event with team
        document.dispatchEvent(new CustomEvent('omp_auth_refresh'));
      }
      return res;
    }
  });

  return apiClient;
};

export default ApiService;
